import React from 'react'
import {useCurrentTheme} from '../../../hooks/useCurrentTheme'
import {TableLogoSvg} from '../../../Trainer/PokerTable/TableLogoSvg'
import styles from './TrainerPreference.module.scss'
import {TableTrainerPlayer} from '../../../Viewer/ViewerTrainerTable/TableTrainerPlayer'
import {getContrastColor} from '../../../helpers/helpers'
import {TableTrainerPot} from '../../../Viewer/ViewerTrainerTable/TableTrainerPot'
import {TableTrainerBoard} from '../../../Viewer/ViewerTrainerTable/TableTrainerBoard'
import {TableTrainerStreetPot} from '../../../Viewer/ViewerTrainerTable/TableTrainerStreetPot'
import {Chip} from '../../../Trainer/PokerTable/ChipSvg'
import {StakeComponent} from '../../../Trainer/PokerTable/Stake'

export const TrainerTable = ({
                                 isTrainerGame = false,
                                 trainerPlayersCoordinates,
                                 playersData,
                                 activePlayer,
                                 playersActions,
                                 toggleBoardModal,
                                 streetTypeCard,
                                 isSettings,
                                 index,
                             }) => {
    const settings = useCurrentTheme()

    console.log('trainerPlayersCoordinates', trainerPlayersCoordinates)
    console.log('playersData', playersData)
    console.log('activePlayer', activePlayer)
    console.log('playersActions', playersActions)
    console.log('streetTypeCard', streetTypeCard)
    console.log('isSettings', isSettings)
    console.log('index', index)

    const dealerPosition = isTrainerGame && playersData?.find((el) => el.is_dealer).name
    const trainerTableColor = settings.trainer.table

    return (
        <div className={styles.trainerTableContainer} style={{display: isTrainerGame && 'flex'}}>
            <svg
                xmlns='http://www.w3.org/2000/svg'
                viewBox='0 0 450.5 225.7'
                width={isTrainerGame ? '100%' : '100%'}
                height='100%'
                style={{
                    minHeight: isTrainerGame ? '50%' : '100%',
                    minWidth: isTrainerGame ? '50%' : '100%',
                    // zIndex: -10,
                    // paddingBottom: isTrainerGame && 25,
                    filter: !isTrainerGame && 'drop-shadow(3px 5px 2px rgb(0 0 0 / 0.4))',
                }}
                preserveAspectRatio
            >
                <defs>
                    <radialGradient id='viewerTrainerTable' cx='50%' cy='200%' fy='0' r='201%'>
                        <stop offset='10%' stopColor={trainerTableColor} stopOpacity='0.8'/>
                        <stop offset='30%' stopColor={trainerTableColor} stopOpacity='0.7'/>
                        <stop offset='40%' stopColor={trainerTableColor} stopOpacity='0.7'/>
                        <stop offset='90%' stopColor={trainerTableColor} stopOpacity='0.8 '/>
                        <stop offset='100%' stopColor={trainerTableColor} stopOpacity='.9 '/>
                    </radialGradient>
                </defs>
                {!isTrainerGame ? (
                    <style>{`.st3{fill:url(#viewerTrainerTable);};} .st4{fill:#272a42;}`}</style>
                ) : (
                    <style>{`.st3{fill:#292C3D} .st4{fill:#272a42;}`}</style>
                )}
                <svg
                    xmlns='http://www.w3.org/2000/svg'
                    viewBox='0 0 450.5 225.7'
                    width='86%'
                    height='100%'
                    x='8%'
                    y='2%'
                    style={{filter: !isTrainerGame && 'drop-shadow(rgba(0, 0, 0, 0.4) 1px 1px 1px)'}}
                >
                    <g>
                        <g>
                            {!isTrainerGame && (
                                <path
                                    className='st3'
                                    d='M110.02,222.79C50.84,222.72,2.7,173.29,2.7,112.59S50.84,2.57,110.02,2.64L340.48,2.9
                            c59.17,0.07,107.31,49.5,107.31,110.19s-48.14,110.02-107.31,109.95L110.02,222.79z'
                                />
                            )}
                            <path
                                className='st3'
                                style={{
                                    filter: !isTrainerGame && 'drop-shadow(rgb(0, 0, 0) 0px 0px 1px)',
                                    fill: '#303034',
                                }}
                                d='M340.48,5.68c57.68,0.07,104.61,48.25,104.61,107.42s-46.93,107.25-104.61,107.18l-230.46-0.26
                            C52.34,219.95,5.41,171.76,5.41,112.6S52.34,5.35,110.02,5.41L340.48,5.68 M340.48,0.13L110.02-0.13C49.25-0.2,0,50.26,0,112.59
                            l0,0c0,62.32,49.25,112.9,110.02,112.97l230.46,0.26c60.76,0.07,110.02-50.4,110.02-112.72l0,0
                            C450.49,50.77,401.24,0.2,340.48,0.13L340.48,0.13z'
                            />
                        </g>
                    </g>
                </svg>

                {trainerPlayersCoordinates &&
                    playersData &&
                    playersData.map(
                        (el) =>
                            trainerPlayersCoordinates[el.name] && (
                                <TableTrainerPlayer
                                    range={el.range}
                                    key={el.name}
                                    bgPos={settings.positions[el.name]}
                                    playerAction={
                                        playersActions &&
                                        (playersActions[el.name].action === 'Check' || el.is_bet) &&
                                        playersActions[el.name].action
                                    }
                                    isFold={el.is_fold}
                                    posFontColor={getContrastColor(settings.positions[el.name])}
                                    position={el.name}
                                    effStack={el.stack}
                                    role={el.name === activePlayer ? 'hero' : 'villain'}
                                    x={trainerPlayersCoordinates[el.name].position.x}
                                    y={trainerPlayersCoordinates[el.name].position.y}
                                />
                            )
                    )}

                {!isTrainerGame && !isSettings && <TableLogoSvg/>}

                {isTrainerGame && trainerPlayersCoordinates && trainerPlayersCoordinates[dealerPosition] && (
                    <Chip coordinates={trainerPlayersCoordinates} dealerPos={dealerPosition} index={index}/>
                )}

                {/* Players stakes*/}
                {playersActions &&
                    trainerPlayersCoordinates &&
                    playersData &&
                    playersData.map(
                        (el) =>
                            !el.is_fold &&
                            el.is_bet && (
                                <StakeComponent
                                    fontSize='11px'
                                    bg={settings.trainer.table}
                                    stake={el.bet}
                                    x={trainerPlayersCoordinates && trainerPlayersCoordinates[el.name].stake.x}
                                    y={trainerPlayersCoordinates && trainerPlayersCoordinates[el.name].stake.y}
                                />
                            )
                    )}
                {isTrainerGame && <TableTrainerPot/>}
                {isTrainerGame && <TableTrainerStreetPot/>}
            </svg>

            {isTrainerGame && (
                <TableTrainerBoard
                    toggleBoardModal={!isSettings ? () => toggleBoardModal(streetTypeCard) : null}
                    isSettings={isSettings}
                    mockBoard={['Qc', 'Qd', 'Qh', 'Qs', '-']}
                    mockQuery={'_F._T._R.'}
                />
            )}
        </div>
    )
}
